// extracted by mini-css-extract-plugin
export var article = "article-module--article--EvJLg";
export var scrTextBgGrey = "article-module--scr-text-bg-grey--2bJyI";